// extracted by mini-css-extract-plugin
export var PageTransition = "r_G";
export var aniBgLoading = "r_f";
export var aniSpin = "r_d";
export var overlay = "r_H";